<div class="ha-family-history-section section-wrapper">
	<div id="medical-family-history" class="medical-section">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.medical-history.family-history.heading'">Family History</span>
		</div>
		<div
			class="radio-btn-label checkbox-text"
			[translate]="'wellness.health-assessment-new.medical-history.family-history.form-fields.conditions'">
			Does your family have a history of any disease?
		</div>
		<div class="checkbox-list" *ngFor="let relation of relationOptions">
			<mat-checkbox
				[disabled]="readOnly"
				appAutofocus
				*ngIf="!relation.hideCheckbox"
				(change)="relationSelection($event, relation)"
				[checked]="relation.checked">
				{{ relation.name }}
			</mat-checkbox>
			<mat-form-field *ngIf="relation.checked">
				<mat-label>
					<span
						[translate]="
							'wellness.health-assessment-new.medical-history.family-history.form-fields.placeholder-condition'
						">
						Condition
					</span>
				</mat-label>
				<mat-select
					multiple
					disableOptionCentering
					panelClass="custom-material-position ha-multi-select-box"
					(selectionChange)="conditionSelection($event, relation)"
					[formControl]="relation.diagnosis">
					<mat-option *ngFor="let option of diagnosisOptions" [value]="option.id">
						{{ option.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<div class="error-msg" *ngIf="relation.showErrorMessage">Please select condition</div>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button
		matStepperNext
		class="button button-medium"
		mat-button
		appEheAnalytics
		[data]="{
			pageUrl: '/ha/new/(medical:family-history)',
			redirectedTo: '/ha/new/(lifestyle:health-goals)',
			componentName: 'FamilyHistory',
			id: 'HA Medical Info - Family History',
			placement: 'ha family history screen'
		}">
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
